import { render } from "./RecuConsultation.vue?vue&type=template&id=7fb5cfae&scoped=true"
import script from "./RecuConsultation.vue?vue&type=script&lang=js"
export * from "./RecuConsultation.vue?vue&type=script&lang=js"

import "./RecuConsultation.vue?vue&type=style&index=0&id=7fb5cfae&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fb5cfae"]])

export default __exports__